<nz-date-picker
  [class]="class"
  [formControl]="control"
  [class.error]="
    (this.isFormSubmitted || this.control?.touched) && this.control?.errors
  "
></nz-date-picker>
@if (isFormSubmitted || (control.status && control?.touched)) {
<div class="mt-2 text-danger">
  @if (control?.errors?.['required']) {
  <div class="validation-error-message">
    Please select {{ label }}
  </div>
  }
</div>
}
